import { useCallback, useState } from 'react';
import { Box, ButtonBase, InputBase, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import Dialog from '../../../../components/Dialog';
import { CircleCloseIcon } from '../../../../components/Icon';
import LongRemark from '../../../../components/LongRemark';
import StatusBed from '../Icons/StatusBed';
import { NEW_BED_STATUS_LENGTH } from '../../../../comm/constant';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#7d86a9',
  },
  input: {
    width: '50%',
    height: '3.5rem',
    padding: '1.25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  closeBtn: {
    position: 'absolute',
    right: 0,
    top: 0,
    transform: 'translate(35%,-35%)',
  },
  closeIcon: {
    fontSize: '2.8rem',
    color: '#7b80ff',
  },
}));

const LinkedBed = ({ bedData, handleClose, handleUpdateLink, handleRemoveLinkedBed, id }) => {
  const classes = useStyles();
  const [form, setForm] = useState({
    linkedBedNo: bedData.linkedBedNo,
    linkedId: bedData.linkedId,
    linkeds: bedData.linkeds,
    deletedBeds: [],
  });
  console.log('bedData', bedData);

  const handleInputLinkedBedNo = useCallback((e) => {
    setForm((o) => ({
      ...o,
      linkedBedNo: e.target.value,
    }));
  }, []);

  const handleDeleteBed = useCallback(
    (bedStatusId) => () => {
      setForm((o) => {
        const deletedBed = _.find(o.linkeds, (item) => item.bedStatusId === bedStatusId);
        o.deletedBeds.push(deletedBed);
        return {
          ...o,
          linkeds: _.filter(o.linkeds, (item) => item.bedStatusId !== bedStatusId),
        };
      });
    },
    []
  );

  const handleUpdate = useCallback(() => {
    handleUpdateLink(id, bedData, form, handleClose);
  }, [handleUpdateLink, form, handleClose, id, bedData]);

  const handleRemove = useCallback(() => {
    handleRemoveLinkedBed(id, bedData, handleClose);
  }, [handleRemoveLinkedBed, bedData, handleClose, id]);

  return (
    <Dialog
      open={true}
      title="Linked Bed"
      cancel="Remove from cubicle"
      confirm="Update"
      cancelStyle={{ border: 'unset', backgroundColor: '#ff655c', color: '#fff' }}
      confirmStyle={{ backgroundColor: '#28d2ab' }}
      dialogfootStyle={{ paddingTop: '1.5rem', borderTop: 'solid 1px #e4e7eb', marginTop: '1.875rem' }}
      handleClose={handleClose}
      handleCancel={handleRemove}
      handleConfirm={handleUpdate}
    >
      <Box display="flex" flexDirection="column" gridGap="2.5rem">
        <Box display="flex" flexDirection="column" gridGap="0.5rem">
          <div className={classes.title}>Bed Number</div>
          <InputBase
            className={classes.input}
            value={form.linkedBedNo}
            onChange={handleInputLinkedBedNo}
            inputProps={{ maxLength: NEW_BED_STATUS_LENGTH.LINKED_BED_NAME }}
          />
        </Box>
        <Box display="flex" flexDirection="column" gridGap="2.5rem">
          <Box display="flex">
            <div className={classes.title}>Included Bed</div>
            <LongRemark content="Included Bed" />
          </Box>
          <Box display="flex" gridGap="2.5rem" flexWrap="wrap">
            {form.linkeds.map((item) => (
              <Box
                width="6.875rem"
                height="6.875rem"
                display="flex"
                justifyContent="center"
                alignItems="center"
                boxShadow="0 0 8px 0 rgba(125, 134, 169, 0.25)"
                borderRadius="8px"
                position="relative"
                key={item.bedNo + item.ccWardCd}
              >
                {form.linkeds.length > 1 && (
                  <ButtonBase className={classes.closeBtn} onClick={handleDeleteBed(item.bedStatusId)}>
                    <CircleCloseIcon className={classes.closeIcon} />
                  </ButtonBase>
                )}
                <StatusBed
                  bedNo={item.bedNo}
                  ward={item.ccWardCd}
                  style={{
                    rootBg: '#fff',
                    bedNoFont: '#538fff',
                    rootBorder: '0.125rem solid #bad2ff',
                    boxBorder: '#bad2ff',
                    boxOpacity: '1',
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default LinkedBed;
